/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AttachmentEntityTypeEnum = "contacts" | "containers" | "messages" | "shipments" | "%future added value";
export type TicketActivityTypeEnum = "comment" | "raise" | "status_change" | "%future added value";
export type TicketDirectionEnum = "incoming" | "outgoing" | "%future added value";
export type TicketStatusEnum = "closed" | "open" | "resolved" | "%future added value";
export type TicketTypeEnum = "add_documents_and_photos" | "misc" | "request_for_documents" | "request_for_shipment_release" | "request_to_add_contact_link" | "request_to_create_a_new_contact" | "request_to_create_a_new_container" | "request_to_create_a_new_poa" | "request_to_create_a_new_shipment" | "request_to_create_container_shipment" | "signed_document_details" | "%future added value";
export type ExternalTicketShowQueryVariables = {
    slug: string;
};
export type ExternalTicketShowQueryResponse = {
    readonly externalTicketShow: {
        readonly slug: string;
        readonly title: string;
        readonly description: string | null;
        readonly status: TicketStatusEnum;
        readonly displayStatus: string;
        readonly direction: TicketDirectionEnum;
        readonly ticketType: TicketTypeEnum;
        readonly raisedAt: string;
        readonly folderSlug: string | null;
        readonly entityType: AttachmentEntityTypeEnum | null;
        readonly entitySlug: string | null;
        readonly activities: ReadonlyArray<{
            readonly sequence: number;
            readonly activityType: TicketActivityTypeEnum;
            readonly slug: string | null;
            readonly body: string | null;
            readonly statusChangedTo: TicketStatusEnum | null;
            readonly meta: string | null;
            readonly performedBy: {
                readonly username: string;
                readonly contact: {
                    readonly name: string;
                    readonly roles: ReadonlyArray<string>;
                    readonly profileUrl: string | null;
                } | null;
            };
            readonly performedAt: string;
        }>;
        readonly action: {
            readonly title: string;
            readonly message: string;
            readonly actionText: string;
        };
        readonly entities: ReadonlyArray<{
            readonly slug: string;
            readonly " $fragmentRefs": FragmentRefs<"ExternalItemLink_item">;
        }>;
        readonly attachments: ReadonlyArray<{
            readonly attachmentSlug: string;
            readonly url: string;
            readonly downloadUrl: string;
            readonly previewUrl: string | null;
            readonly name: string;
            readonly contentType: string;
        }>;
        readonly container: {
            readonly slug: string;
            readonly containerNumber: string;
            readonly containerType: string;
            readonly terminalDate: string | null;
            readonly dischargeDate: string | null;
            readonly voyage: {
                readonly name: string;
                readonly etd: string | null;
                readonly eta: string | null;
                readonly sourcePortCode: string | null;
                readonly destinationPortCode: string | null;
                readonly vessel: {
                    readonly name: string;
                    readonly imoNumber: string | null;
                };
            };
        } | null;
        readonly pickedBy: {
            readonly slug: string;
            readonly name: string;
            readonly profileUrl: string | null;
        } | null;
        readonly raisedBy: {
            readonly slug: string;
            readonly name: string;
            readonly profileUrl: string | null;
        };
        readonly raisedFor: {
            readonly slug: string;
            readonly name: string;
            readonly profileUrl: string | null;
        } | null;
        readonly contact: {
            readonly firstName: string;
            readonly lastName: string;
            readonly email: string | null;
            readonly format: string | null;
            readonly businessPhone: string;
            readonly language: string | null;
            readonly country: string | null;
            readonly company: string | null;
            readonly address: string | null;
            readonly postcode: string | null;
            readonly place: string | null;
            readonly salutation: string;
            readonly state: string | null;
            readonly roles: ReadonlyArray<string>;
        } | null;
        readonly contactLink: {
            readonly firstName: string;
            readonly lastName: string | null;
            readonly email: string | null;
            readonly format: string | null;
            readonly businessPhone: string | null;
            readonly language: string | null;
            readonly country: string | null;
            readonly company: string | null;
            readonly address: string | null;
            readonly postcode: string | null;
            readonly place: string | null;
            readonly salutation: string | null;
            readonly state: string | null;
            readonly roles: ReadonlyArray<string>;
        } | null;
        readonly shipment: {
            readonly shipmentType: string;
            readonly containerSlug: string;
            readonly description: string;
            readonly weight: number | null;
            readonly vin: string | null;
            readonly deliveryLocation: string | null;
        } | null;
    };
};
export type ExternalTicketShowQuery = {
    readonly response: ExternalTicketShowQueryResponse;
    readonly variables: ExternalTicketShowQueryVariables;
};



/*
query ExternalTicketShowQuery(
  $slug: String!
) {
  externalTicketShow(slug: $slug) {
    slug
    title
    description
    status
    displayStatus
    direction
    ticketType
    raisedAt
    folderSlug
    entityType
    entitySlug
    activities {
      sequence
      activityType
      slug
      body
      statusChangedTo
      meta
      performedBy {
        username
        contact {
          name
          roles
          profileUrl
          id
        }
      }
      performedAt
    }
    action {
      title
      message
      actionText
    }
    entities {
      slug
      ...ExternalItemLink_item
      id
    }
    attachments {
      attachmentSlug
      url
      downloadUrl
      previewUrl
      name
      contentType
      id
    }
    container {
      slug
      containerNumber
      containerType
      terminalDate
      dischargeDate
      voyage {
        name
        etd
        eta
        sourcePortCode
        destinationPortCode
        vessel {
          name
          imoNumber
          id
        }
        id
      }
      id
    }
    pickedBy {
      slug
      name
      profileUrl
      id
    }
    raisedBy {
      slug
      name
      profileUrl
      id
    }
    raisedFor {
      slug
      name
      profileUrl
      id
    }
    contact {
      firstName
      lastName
      email
      format
      businessPhone
      language
      country
      company
      address
      postcode
      place
      salutation
      state
      roles
      id
    }
    contactLink {
      firstName
      lastName
      email
      format
      businessPhone
      language
      country
      company
      address
      postcode
      place
      salutation
      state
      roles
      id
    }
    shipment {
      shipmentType
      containerSlug
      description
      weight
      vin
      deliveryLocation
      id
    }
    id
  }
}

fragment ExternalItemLink_item on ExternalListItem {
  title
  path
  itemType
  slug
  image {
    url
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayStatus",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "direction",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ticketType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "raisedAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "folderSlug",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entitySlug",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activityType",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusChangedTo",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meta",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roles",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "performedAt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "TicketAction",
  "kind": "LinkedField",
  "name": "action",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actionText",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attachmentSlug",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "downloadUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previewUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containerNumber",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containerType",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "terminalDate",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dischargeDate",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "etd",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eta",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourcePortCode",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "destinationPortCode",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imoNumber",
  "storageKey": null
},
v38 = [
  (v2/*: any*/),
  (v19/*: any*/),
  (v21/*: any*/)
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "format",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessPhone",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "company",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postcode",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "place",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salutation",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v52 = [
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/),
  (v43/*: any*/),
  (v44/*: any*/),
  (v45/*: any*/),
  (v46/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/),
  (v51/*: any*/),
  (v20/*: any*/)
],
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shipmentType",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "containerSlug",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "weight",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vin",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deliveryLocation",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v59 = [
  (v2/*: any*/),
  (v19/*: any*/),
  (v21/*: any*/),
  (v58/*: any*/)
],
v60 = [
  (v39/*: any*/),
  (v40/*: any*/),
  (v41/*: any*/),
  (v42/*: any*/),
  (v43/*: any*/),
  (v44/*: any*/),
  (v45/*: any*/),
  (v46/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/),
  (v49/*: any*/),
  (v50/*: any*/),
  (v51/*: any*/),
  (v20/*: any*/),
  (v58/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalTicketShowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExternalTicket",
        "kind": "LinkedField",
        "name": "externalTicketShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketActivity",
            "kind": "LinkedField",
            "name": "activities",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v2/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "performedBy",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "contact",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ExternalListItem",
            "kind": "LinkedField",
            "name": "entities",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ExternalItemLink_item"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketAttachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v19/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContainer",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Voyage",
                "kind": "LinkedField",
                "name": "voyage",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vessel",
                    "kind": "LinkedField",
                    "name": "vessel",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v37/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "pickedBy",
            "plural": false,
            "selections": (v38/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "raisedBy",
            "plural": false,
            "selections": (v38/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "raisedFor",
            "plural": false,
            "selections": (v38/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": (v52/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contactLink",
            "plural": false,
            "selections": (v52/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftShipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v53/*: any*/),
              (v54/*: any*/),
              (v4/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExternalTicketShowQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ExternalTicket",
        "kind": "LinkedField",
        "name": "externalTicketShow",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketActivity",
            "kind": "LinkedField",
            "name": "activities",
            "plural": true,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v2/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "performedBy",
                "plural": false,
                "selections": [
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Contact",
                    "kind": "LinkedField",
                    "name": "contact",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v20/*: any*/),
                      (v21/*: any*/),
                      (v58/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v22/*: any*/)
            ],
            "storageKey": null
          },
          (v23/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ExternalListItem",
            "kind": "LinkedField",
            "name": "entities",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "path",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "itemType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "image",
                "plural": false,
                "selections": [
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              (v58/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TicketAttachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v19/*: any*/),
              (v28/*: any*/),
              (v58/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContainer",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Voyage",
                "kind": "LinkedField",
                "name": "voyage",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/),
                  (v35/*: any*/),
                  (v36/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Vessel",
                    "kind": "LinkedField",
                    "name": "vessel",
                    "plural": false,
                    "selections": [
                      (v19/*: any*/),
                      (v37/*: any*/),
                      (v58/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v58/*: any*/)
                ],
                "storageKey": null
              },
              (v58/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "pickedBy",
            "plural": false,
            "selections": (v59/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "raisedBy",
            "plural": false,
            "selections": (v59/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "raisedFor",
            "plural": false,
            "selections": (v59/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftContact",
            "kind": "LinkedField",
            "name": "contact",
            "plural": false,
            "selections": (v60/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Contact",
            "kind": "LinkedField",
            "name": "contactLink",
            "plural": false,
            "selections": (v60/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DraftShipment",
            "kind": "LinkedField",
            "name": "shipment",
            "plural": false,
            "selections": [
              (v53/*: any*/),
              (v54/*: any*/),
              (v4/*: any*/),
              (v55/*: any*/),
              (v56/*: any*/),
              (v57/*: any*/),
              (v58/*: any*/)
            ],
            "storageKey": null
          },
          (v58/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fbeeb1148e6f82d6126c0028d68bb8cd",
    "id": null,
    "metadata": {},
    "name": "ExternalTicketShowQuery",
    "operationKind": "query",
    "text": "query ExternalTicketShowQuery(\n  $slug: String!\n) {\n  externalTicketShow(slug: $slug) {\n    slug\n    title\n    description\n    status\n    displayStatus\n    direction\n    ticketType\n    raisedAt\n    folderSlug\n    entityType\n    entitySlug\n    activities {\n      sequence\n      activityType\n      slug\n      body\n      statusChangedTo\n      meta\n      performedBy {\n        username\n        contact {\n          name\n          roles\n          profileUrl\n          id\n        }\n      }\n      performedAt\n    }\n    action {\n      title\n      message\n      actionText\n    }\n    entities {\n      slug\n      ...ExternalItemLink_item\n      id\n    }\n    attachments {\n      attachmentSlug\n      url\n      downloadUrl\n      previewUrl\n      name\n      contentType\n      id\n    }\n    container {\n      slug\n      containerNumber\n      containerType\n      terminalDate\n      dischargeDate\n      voyage {\n        name\n        etd\n        eta\n        sourcePortCode\n        destinationPortCode\n        vessel {\n          name\n          imoNumber\n          id\n        }\n        id\n      }\n      id\n    }\n    pickedBy {\n      slug\n      name\n      profileUrl\n      id\n    }\n    raisedBy {\n      slug\n      name\n      profileUrl\n      id\n    }\n    raisedFor {\n      slug\n      name\n      profileUrl\n      id\n    }\n    contact {\n      firstName\n      lastName\n      email\n      format\n      businessPhone\n      language\n      country\n      company\n      address\n      postcode\n      place\n      salutation\n      state\n      roles\n      id\n    }\n    contactLink {\n      firstName\n      lastName\n      email\n      format\n      businessPhone\n      language\n      country\n      company\n      address\n      postcode\n      place\n      salutation\n      state\n      roles\n      id\n    }\n    shipment {\n      shipmentType\n      containerSlug\n      description\n      weight\n      vin\n      deliveryLocation\n      id\n    }\n    id\n  }\n}\n\nfragment ExternalItemLink_item on ExternalListItem {\n  title\n  path\n  itemType\n  slug\n  image {\n    url\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cde0bc6b92c27db9cceee3d55deceffb';
export default node;
